import api from 'plugin/api';

/**
 *  @description 공장  API
 */

async function factory() {
  const url = '/common/plant-haccp?haccpYn=Y';

  const response = await api.get(url);
  return response;
}

/**
 *  @description 분류코드목록  API
 */

async function category() {
  const url = '/category/ctgryGrpCd';

  const response = await api.get(url);
  return response;
}

/**
 *  @description 분류코드1(대분류) 목록  API
 */

async function category1(params) {
  const url = '/category/ctgry1Cd';

  const response = await api.get(url, { params });
  return response;
}

/**
 *  @description 분류코드2(중분류) 목록  API
 */

async function category2(params) {
  const url = '/category/ctgry2Cd';

  const response = await api.get(url, { params });
  return response;
}

/**
 *  @description 분류코드3(소분류) 목록  API
 */

async function category3(params) {
  const url = '/category/ctgry3Cd';

  const response = await api.get(url, { params });
  return response;
}

async function commonCode(params) {
  const url = '/code';

  const response = await api.get(url, { params });
  return response;
}

export { factory, category, category1, category2, category3, commonCode };
